import { API_URL } from "../utils/ApiUrl";

// taskService.js
export const updateTaskStatus = async (taskId) => {
    const accessToken = localStorage.getItem('accessToken');
    const url = `${API_URL}tasks/${taskId}/status-completed`;

    const headers = {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
    };

    const payload = {
        status: "completed",
    };

    try {
        const response = await fetch(url, {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            throw new Error('Failed to update task status');
        }

        const data = await response.json();
        return data;  // Return the response data to be used in the parent component
    } catch (error) {
        console.error('Error updating task:', error);
        throw error;  // Re-throw the error so parent can handle it
    }
};

// // Call the function with taskId and accessToken
// const taskId = 123;  // Example task ID
// const accessToken = 'your-access-token';  // Your actual access token
// updateTaskStatus(taskId, accessToken);
